import { useEffect, useState } from "react";
import {
  fetchAdminStats,
  fetchAdminUsers,
  fetchAdminSearches,
  addTokensToUser,
  fetchCuratorApplications,
  approveCurator,
  rejectCurator,
} from "./admin.api";

const AdminDashboard = () => {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);
  const [searches, setSearches] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [activeTab, setActiveTab] = useState("users"); // 🔥 NEW
  const [loading, setLoading] = useState(true);
  const [userPage, setUserPage] = useState(1);

const [guestPage, setGuestPage] = useState(1);
const [showTokenModal, setShowTokenModal] = useState(false);
const [selectedUserId, setSelectedUserId] = useState(null);
const [tokenInput, setTokenInput] = useState("");
const [applications , setApplications] = useState([]);



const LIMIT = 10;
  useEffect(() => {
    const load = async () => {
      try {
        const s = await fetchAdminStats();
        const u = await fetchAdminUsers();
        const sh = await fetchAdminSearches();

        setStats(s);
        setUsers(u);
        setSearches(sh);
      } catch (err) {
        console.error("ADMIN LOAD ERROR 👉", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);
const handleAddTokens = async () => {
  const tokens = Number(tokenInput);

  if (isNaN(tokens) || tokens <= 0) {
    alert("Invalid token amount");
    return;
  }

  try {
    await addTokensToUser(selectedUserId, tokens);

    const updatedUsers = await fetchAdminUsers();
    setUsers(updatedUsers);

    setShowTokenModal(false);
    setTokenInput("");

  } catch (err) {
    console.error(err);
    alert("Failed to add tokens");
  }
};
 
useEffect(() => {
  fetchCuratorApplications().then(setApplications);
}, []);
  if (loading) return <div className="p-6">Loading admin dashboard…</div>;
  if (!stats)
    return <div className="p-6 text-red-600">Failed to load admin data</div>;

  const guestSearches = searches.filter((s) => s.isGuest);
  const userSearches = searches.filter((s) => !s.isGuest);

  const paginatedUsers = users.slice(
  (userPage - 1) * LIMIT,
  userPage * LIMIT
);

// ✅ GUEST PAGINATION
const paginatedGuestSearches = guestSearches.slice(
  (guestPage - 1) * LIMIT,
  guestPage * LIMIT
);

// ✅ TOTAL PAGES
const userPages = Math.ceil(users.length / LIMIT);
const guestPages = Math.ceil(guestSearches.length / LIMIT);
  return (
    <div className=" bg-white max-w-6xl mx-auto p-6 space-y-8">
      <h1 className="text-2xl font-semibold">Admin Dashboard</h1>

      {/* ================= STATS ================= */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        <Stat title="Total Users" value={stats.totalUsers} />
        <Stat title="Total Tokens" value={stats.totalTokens} />
        <Stat title="Guest Searches" value={guestSearches.length} />
        <Stat title="User Searches" value={userSearches.length} />
      </div>

      {/* ================= TABS ================= */}
      <div className="flex gap-4 border-b pb-3">
        <button
          onClick={() => {
            setActiveTab("users");
            setSelectedUser(null);
          }}
          className={`px-4 py-2 rounded ${
            activeTab === "users"
              ? "bg-black text-white"
              : "bg-gray-100"
          }`}
        >
          Users
        </button>

        <button
          onClick={() => {
            setActiveTab("guests");
            setSelectedUser(null);
          }}
          className={`px-4 py-2 rounded ${
            activeTab === "guests"
              ? "bg-black text-white"
              : "bg-gray-100"
          }`}
        >
          Guests
        </button>

        <button
          onClick={() => {
            setActiveTab("curators");
            setSelectedUser(null);
          }}
          className={`px-4 py-2 rounded ${
            activeTab === "curators" ? "bg-black text-white" : "bg-gray-100"
          }`}
        >
          Curators
        </button>
      </div>

      {/* ================= USERS TAB ================= */}
     {activeTab === "users" && (
  <>
    <div className="bg-white rounded-xl shadow overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left">Name</th>
            <th className="px-4 py-3 text-center">Tokens</th>
            <th className="px-4 py-3 text-right">Joined</th>
            <th className="px-4 py-3 text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          {paginatedUsers.map((u) => (
            <tr
              key={u._id}
              onClick={() => setSelectedUser(u)}
              className={`border-t cursor-pointer hover:bg-gray-50 ${
                selectedUser?._id === u._id ? "bg-gray-100" : ""
              }`}
            >
              <td className="px-4 py-3">{u.name}</td>
              <td className="px-4 py-3 text-center font-semibold">
                {u.tokens}
              </td>
              <td className="px-4 py-3 text-right text-gray-500">
                {new Date(u.createdAt).toLocaleDateString()}
              </td>

              <td className="px-4 py-3 text-center">
                <button
                  onClick={(e) => {
                    e.stopPropagation(); // IMPORTANT (prevents row click)
                    setSelectedUserId(u._id);
                    setShowTokenModal(true);
                  }}
                  className="px-3 py-1 text-xs bg-black text-white rounded hover:opacity-80"
                >
                  + Tokens
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

    {/* ✅ USERS PAGINATION */}
    <div className="flex justify-between items-center mt-4">
      <button
        disabled={userPage === 1}
        onClick={() => setUserPage((p) => p - 1)}
        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
      >
        Prev
      </button>

      <span className="text-sm">
        Page {userPage} of {userPages}
      </span>

      <button
        disabled={userPage === userPages}
        onClick={() => setUserPage((p) => p + 1)}
        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
      >
        Next
      </button>
    </div>

    {/* ✅ USER SEARCH HISTORY */}
    {selectedUser && (
      <SearchTable
        title={`Search History — ${selectedUser.name}`}
        searches={searches.filter(
          (s) => s.user?._id === selectedUser._id
        )}
      />
    )}
  </>
)}


      {/* ================= GUEST TAB ================= */}
     {activeTab === "guests" && (
  <>
    <SearchTable
      title="Guest Search History"
      searches={paginatedGuestSearches}
    />

    {/* ✅ GUEST PAGINATION */}
    <div className="flex justify-between items-center mt-4">
      <button
        disabled={guestPage === 1}
        onClick={() => setGuestPage((p) => p - 1)}
        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
      >
        Prev
      </button>

      <span className="text-sm">
        Page {guestPage} of {guestPages}
      </span>

      <button
        disabled={guestPage === guestPages}
        onClick={() => setGuestPage((p) => p + 1)}
        className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
      >
        Next
      </button>
    </div>
  </>
)}
{showTokenModal && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
    
    <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-xl">
      
      <h2 className="text-lg font-semibold mb-4">
        Add Tokens
      </h2>
      <h3 className="text-xs mb-2">You can only add upto 100 token </h3>

      <input
        type="number"
        placeholder="Enter tokens"
        value={tokenInput}
        onChange={(e) => setTokenInput(e.target.value)}
        className="w-full border rounded-lg px-3 py-2 mb-4 outline-none focus:ring-2 focus:ring-black"
      />

      <div className="flex justify-end gap-3">
        <button
          onClick={() => {
            setShowTokenModal(false);
            setTokenInput("");
          }}
          className="px-4 py-2 text-sm bg-gray-200 rounded"
        >
          Cancel
        </button>

        <button
          onClick={handleAddTokens}
          className="px-4 py-2 text-sm bg-black text-white rounded"
        >
          Add
        </button>
      </div>

    </div>
  </div>
)}

{activeTab === "curators" && (
  <div className="bg-white rounded-xl shadow p-6">
    <h2 className="text-lg font-semibold mb-4">
      Travel Curator Applications
    </h2>

    {applications.length === 0 ? (
      <p className="text-gray-500">No applications found</p>
    ) : (
      <table className="w-full text-sm">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-2 text-left">Name</th>
            <th className="px-4 py-2 text-left">Platform</th>
            <th className="px-4 py-2 text-left">Followers</th>
            <th className="px-4 py-2 text-center">Status</th>
            <th className="px-4 py-2 text-center">Actions</th>
          </tr>
        </thead>

        <tbody>
          {applications.map((app) => (
            <tr key={app._id} className="border-t">
              <td className="px-4 py-2">{app.fullName}</td>

              <td className="px-4 py-2">
                {app.primaryPlatform}
              </td>

              <td className="px-4 py-2">
                {app.instagram?.followers ||
                  app.youtube?.subscribers ||
                  "-"}
              </td>

              <td className="px-4 py-2 text-center capitalize">
                {app.status}
              </td>

              <td className="px-4 py-2 flex gap-2 justify-center">
                <button
                  onClick={async () => {
                    await approveCurator(app._id);
                    const updated = await fetchCuratorApplications();
                    setApplications(updated);
                  }}
                  className="px-3 py-1 bg-green-600 text-white rounded text-xs"
                >
                  Approve
                </button>

                <button
                  onClick={async () => {
                    await rejectCurator(app._id);
                    const updated = await fetchCuratorApplications();
                    setApplications(updated);
                  }}
                  className="px-3 py-1 bg-red-600 text-white rounded text-xs"
                >
                  Reject
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </div>
)}
    </div>
  );
};



/* ================= REUSABLE SEARCH TABLE ================= */
const SearchTable = ({ title, searches }) => (
  <div className="bg-white rounded-xl shadow p-6">
    <h2 className="text-lg font-semibold mb-4">{title}</h2>

    {searches.length === 0 ? (
      <p className="text-center text-gray-500 py-6">
        No searches found
      </p>
    ) : (
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-4 py-2 text-left">Search</th>
              <th className="px-4 py-2 text-center">Tokens</th>
              <th className="px-4 py-2 text-right">Time</th>
            </tr>
          </thead>
          <tbody>
            {searches.map((s) => (
              <tr key={s._id} className="border-t">
                <td className="px-4 py-2">{s.place}</td>
                <td className="px-4 py-2 text-center font-semibold">
                  {s.tokensUsed}
                </td>
                <td className="px-4 py-2 text-right text-gray-500">
                  {new Date(s.createdAt).toLocaleString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
  </div>
);



const Stat = ({ title, value }) => (
  <div className="bg-white rounded-xl p-5 shadow">
    <p className="text-sm text-gray-500">{title}</p>
    <p className="text-2xl font-bold mt-2">{value}</p>
  </div>
);



export default AdminDashboard;